import {openApi} from '../../../helpers/request'
import { makeAutoObservable } from 'mobx'
import { FormEvent } from 'react'
import i from '../../../translations/i'
import { notification } from 'antd'

export class WarehousesController {

    list: any = []
    listLoadedKey: string | null = null
    listLoadingKey: string | null = null

    element:any = {

    }
    pagination = { total: 0, limit: 10, page: 1, offset: 0 }

    zones: any[] = []
    places = []
    timezones: any[] = []

    constructor() {
        makeAutoObservable(this)
    }

    // Список часовых поясов для выпадающего списка. Пустое значение = пояс проекта.
    getTimezones() {
        if (this.timezones.length > 0) return

        openApi('get', '/setting/timezones')
            .then(result => {
                this.timezones = result.data
            })
            .catch(error => console.log(error))
    }

    getZones() {
        openApi('get', "/setting/delivery_zone")
            .then(success => {
                this.zones = success.data
            })
            .catch(error => console.log(error));
    }

    getPlaces() {

        openApi('get', `/places?limit=100000000`)
            .then((result) => {
                this.places = result.data
            })
    }

    setPage(page: number) {
        this.pagination.page = page
        this.get()
    }

    getElement(id: any) {
        openApi('get', `/warehouses/${id}`)
            .then(result => {
                console.log(result)
                result = result.data
                this.element = {
                    ...result,
                    city_ids: (result.cities ?? []).map((el: any) => el.id),
                    zones: (result.zones ?? []).map((el: any) => el.id),
                    places: (result.places ?? []).map((el: any) => el.id),
                }
            })
    }

    get(limit: null | Number = null, force = false, cityId: number | null = null) {
        let _limit = limit ? limit : this.pagination.limit
        const key = `${_limit}:${this.pagination.page}:${cityId ?? 'all'}`

        if (!force && (this.listLoadedKey === key || this.listLoadingKey === key)) return

        this.listLoadingKey = key

        const cityFilter = cityId ? `&city_id=${cityId}` : ''

        openApi('get', `/warehouses?limit=${_limit}&page=${this.pagination.page}${cityFilter}`)
            .then(result => {
                result = result.data
                this.pagination.total = result.size
                this.pagination.page = result.page
                this.pagination.limit = result.limit
                this.list = result.items
                this.listLoadedKey = key
            })
            .finally(() => {
                this.listLoadingKey = null
            })
    }

    onChange(name: string, value: any) {
        if(name === 'coordinates') {
            this.element.latitude = value[0]
            this.element.longitude = value[1]
        } else if(name === 'zone') {
            this.element.zones = value
        } else if(name === 'place') {
            this.element.places = value
        } else {
            this.element[name] = value
        }
    }

    save(e: FormEvent) {
        e.preventDefault()

        const path = this.element.id && this.element.id > 0 ? `/warehouses/${this.element.id}` : `/warehouses`

        const data = new FormData()
        data.append('name', this.element.name);
        (this.element.city_ids ?? []).forEach((cityId: number) => {
            data.append('city_ids[]', `${cityId}`)
        })
        data.append('latitude', this.element.latitude ?? 0)
        data.append('longitude', this.element.longitude ?? 0)
        data.append('picture', this.element.picture)
        data.append('enabled', `${+ this.element.enabled}`)
        data.append('show_availability', `${+ this.element.show_availability}`)
        if(this.element.id_crm) data.append('id_crm', this.element.id_crm)
        // Пустая строка = наследовать часовой пояс проекта
        data.append('timezone', this.element.timezone ?? '')


        this.element.zones && this.element.zones.length > 0 && this.element.zones.map((el:any) => data.append('deliveryzoneid[]', el))
        this.element.places && this.element.places.length > 0 && this.element.places.map((el:any) => data.append('place_id[]', el))

        openApi('post', path, data)
            .then(result => {
                if(!this.element.id || this.element.id === 0) window.location.href = `/settings/warehouses`
                else {
                    this.getElement(this.element.id)
                    notification.success({
                        message: i.t('def:success.complete'),
                        description: i.t('def:success.edit')
                    });
                }
            })
            .catch(error => {
                console.log(error.response)
                notification.error({
                    message: i.t('def:errors.error'),
                    description: error.response.data.data.message
                })
            })

    }

    remove(id: any) {
        if(window.confirm(i.t('def:confirms.delete'))) {
            openApi('delete', `/warehouses/${id}`)
                .then(success => {
                    this.get(null, true)
                })
        }
    }

    upload(image: any) {
        this.element.picture = image
        return false
    }

    removeImage(id: string | number) {
        if(window.confirm(i.t('def:confirms.delete'))) {
            openApi('delete', `/warehouses/picture/${id}`)
                .then(result => {
                    this.getElement(id)
                })
        }
    }
}